module.exports = __webpack_public_path__ + "img/landing-page.d7487c67.jpg";